module.exports = __webpack_public_path__ + "b8df198162485930c980a73121a66731.pdf";